import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotaFiscal } from 'src/app/models/nota-fiscal';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotaFiscalService } from 'src/app/services/nota-fiscal.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import swal from 'sweetalert2';
import { UtilitarioService } from './../../services/utilitario.service';

@Component({
  selector: 'app-nota-fiscal-modal',
  templateUrl: './nota-fiscal-modal.component.html',
  styleUrls: ['./nota-fiscal-modal.component.scss']
})
export class NotaFiscalModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  notaFiscal: NotaFiscal;
  chave = '';
  financiamento = false;


  constructor(public dialogRef: MatDialogRef<NotaFiscalModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    private notaFiscalService: NotaFiscalService, private utilitarioService: UtilitarioService) { }

  ngOnInit() {

  }

  buscarNota() {
    this.carregandoService.mostra('buscarNota');
    this.notaFiscal = undefined;
    this.notaFiscalService.buscarNota(this.chave).subscribe(nota => {
      this.notaFiscal = nota;
      this.carregandoService.esconde('buscarNota');
    }, (erro) => {
      this.carregandoService.esconde('buscarNota');
      // this.notificacaoService.erro(erro);
      swal(
        {
          title: '',
          text: 'Nota fiscal não encontrada!!!',
          type: 'warning',
          confirmButtonClass: 'btn btn-info',
          buttonsStyling: false
        }
      );
    });
  }

  vincular() {
    this.dialogRef.close(this.notaFiscal.nNota);
  }

  fechar() {
    this.dialogRef.close();
  }

  imprimirNota() {
    this.carregandoService.mostra('imprimirNota');

    this.notaFiscalService.imprimirNotaPorNNota(this.notaFiscal.nNota).subscribe(resp => {

      this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
      this.utilitarioService.openBlob(resp);

      this.carregandoService.esconde('imprimirNota');



    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('imprimirNota');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }
}
